import React, {Component} from 'react'
import AdminFilterInput from "./AdminFilterInput";
import SearchField from "../Fields/SearchField";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SettingsDialog from "../Fields/SettingsDialog";
import SearchFormDates from "./SearchFormDates";
import moment from 'moment'
moment.locale('fi-fi')

export default class AdminFilterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterBy: '',
            filterType: '',
            filterValue: '',
            presetName: '',
            presetOnSaveMode: false,
            showFilterForm: false,
            from: moment().subtract(6, 'day'),
            to: moment()
        };

        this.filterTypeLabels = []
        this.filterTypeLabels['equals'] = '='
        this.filterTypeLabels['greater'] = '>'
        this.filterTypeLabels['lesser'] = '<'
        this.filterTypeLabels['contains'] = 'sisältää'
        this.filterTypeLabels['regex'] = 'regex'
        this.filterTypeLabels['is_null'] = 'on tyhjä'
        this.filterTypeLabels['is_not_null'] = 'ei ole tyhjä'

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const currentFilterType = this.getCurrentFilterType()
        if (currentFilterType === 'date') {
            this.setState({filterType: 'date'})
        }
        this.setState({[event.target.name]: event.target.value})
    }

    clearInputsAfterSubmit = () => {
        this.setState({
            filterBy: '',
            filterType: '',
            filterValue: ''
        });
    }

    handleSubmit(event) {
        event.preventDefault()
        if (this.state.filterBy === '' || this.state.filterType === '') {
            alert('Filter not selected')
            return;
        }
        const newFilter = {[this.state.filterBy]: this.state.filterType + '|' + this.state.filterValue}

        this.props.onSubmit(newFilter)
        this.clearInputsAfterSubmit()
    }

    onRemoveFilter(filterId) {
        this.props.onRemoveFilter(filterId)
    }

    onToggleFilterForm = () => {
        this.setState({showFilterForm: !this.state.showFilterForm})
    }

    setPresetOnSaveMode() {
        this.setState({
            presetOnSaveMode: true,
            presetName: ''
        });
    }

    onSaveFilters = (key) => {
        this.setState({
            presetOnSaveMode: false,
            presetName: ''
        });
        this.props.onSaveFilters(key);
    }

    onRemoveSavedFilters = (key) => {
        this.props.onRemoveSavedFilters(key);
    }

    getCurrentFilterType = () => {
        const alias = this.state.filterBy
        let type = 'text'
        if (alias.substring(alias.length - 3, alias.length) === '_at' || alias.substring(0, 5) === 'date_') {
            type = 'date'
        }
        return type
    }
    onFilterDate = (filter) => {
        const dateString = (filter.from ? filter.from.format('YYYY-MM-DD') : '') + ' - ' + (filter.to ? filter.to.format('YYYY-MM-DD') : '')
        const newFilter = {created_at: 'date|' + dateString}
        this.props.onSubmit(newFilter)
        this.setState({from: filter.from, to: filter.to})
    }

    render() {
        const {
            columns,
            savedFilters,
            onSetSavedFilters,
            handleSearchSubmit,
            onSearchChanged,
            search,
            fullScreen,
            open,
            handleClose,
            viewType,
            onViewTypeSelect,
            childViewType,
            availableColumns,
            onColumnChange,
            checkedColumns,
            availableChildColumns,
            checkedChildColumns,
            limit,
            onLimitSelect,
            country,
            onCountrySelect,
            showChilds,
            toggleShowChildren,
            showChildHeader,
            toggleChildHeader,
            cacheUpdating,
            onFileExport,
            updateStatsCache,
            update,
            handleClickOpen
        } = this.props

        const currentFilterType = this.getCurrentFilterType()
        let filters = this.props.filters;
        delete filters.limit
        delete filters.default

        let filterShown = false

        return (
            <>
                {savedFilters && Object.keys(savedFilters).length > 0 && <>
                    <div className="row">
                        <div className="col-12 col-md-5 mb-3">
                            <SearchField
                                handleSearchSubmit={handleSearchSubmit}
                                onSearchChanged={onSearchChanged}
                                search={search}/>
                        </div>
                        <div className="col-12 col-md-7" style={{display: 'flex'}}>
                            {false && <button type="submit" className="btn px-3 btn-outline float-right mb-3"
                                              onClick={handleClickOpen}
                                              style={{cursor: 'pointer'}}>
                                <FontAwesomeIcon size="lg" icon={['fal', 'cog']}/>
                            </button>}
                            <div style={{flexGrow: 1}} className={'mb-3'}>
                                <div className={'btn px-3 btn-outline'}
                                     onClick={() => update(filters)}
                                >
                                    <i className="fas fa-redo"></i>
                                </div>
                            </div>
                            <div className="ml-3">
                                <SearchFormDates onFilter={this.onFilterDate} from={this.state.from}
                                                 to={this.state.to}/>
                            </div>
                        </div>
                        <div className="col-12 mb-2">
                            <div style={{overflowX: 'auto', whiteSpace: 'nowrap', padding: '0 5px'}}>
                                {Object.keys(savedFilters).map((key) => {
                                        return (
                                            <span className="badge badge-lg badge-light mr-2 px-2 pl-3 mb-2" key={key}><span
                                                className="badge badge-primary mr-1 select-badge"
                                                onClick={() => onSetSavedFilters(key)}><i
                                                className="fas fa-check"></i></span>
                                                {key}
                                                {!savedFilters[key].default && <span
                                                    className="badge ml-1" onClick={() => this.onRemoveSavedFilters(key)}><i
                                                    className="fas fa-times"></i></span>}
                                            </span>
                                        )
                                    }
                                )}
                                <span className="badge ml-1" onClick={this.onToggleFilterForm}
                                      style={{cursor: 'pointer'}}>
                  <FontAwesomeIcon icon={['fal', 'plus']}/> Lisää ehto
                </span>
                            </div>
                        </div>
                    </div>
                </>}
                <SettingsDialog
                    fullScreen={fullScreen}
                    open={open}
                    handleClose={handleClose}
                    viewType={viewType}
                    onViewTypeSelect={onViewTypeSelect}
                    childViewType={childViewType}
                    availableColumns={availableColumns}
                    onColumnChange={onColumnChange}
                    checkedColumns={checkedColumns}
                    availableChildColumns={availableChildColumns}
                    checkedChildColumns={checkedChildColumns}
                    limit={limit}
                    onLimitSelect={onLimitSelect}
                    country={country}
                    onCountrySelect={onCountrySelect}
                    showChilds={showChilds}
                    toggleShowChildren={toggleShowChildren}
                    showChildHeader={showChildHeader}
                    toggleChildHeader={toggleChildHeader}
                    filters={filters}
                    cacheUpdating={cacheUpdating}
                    onFileExport={onFileExport}
                    updateStatsCache={updateStatsCache}
                    update={update}
                />
                {this.state.showFilterForm && <>
                    <form onSubmit={this.handleSubmit}>
                        <div className="row mb-3 filter-row">
                            <div className="col-6 col-md-3">
                                <label className="label">Add Filter By</label>
                                <select
                                    name="filterBy"
                                    className="form-control"
                                    value={this.state.filterBy}
                                    onChange={this.handleChange}
                                >
                                    <option value={''}>Select</option>
                                    {columns.map((value, index) => (
                                        value.alias.map((aliasValue, aliasIndex) => (
                                            <option value={aliasValue} key={index + '-' + aliasIndex}>
                                                {value.alias.length > 1 && value.label + ': ' + aliasValue}
                                                {value.alias.length === 1 && value.label}
                                            </option>
                                        ))
                                    ))}
                                </select>
                            </div>
                            <div className="col-6 col-md-3">
                                {currentFilterType !== 'date' && <>
                                    <label className="label">Filter Type</label>
                                    <select
                                        name="filterType"
                                        className="form-control"
                                        value={this.state.filterType}
                                        onChange={this.handleChange}
                                    >
                                        <option value={''} key={'select'}>Select</option>
                                        <option value='equals' key={'equals'}>{this.filterTypeLabels['equals']}</option>
                                        <option value='contains'
                                                key={'contains'}>{this.filterTypeLabels['contains']}</option>
                                        <option value='greater'
                                                key={'greater'}>{this.filterTypeLabels['greater']}</option>
                                        <option value='lesser' key={'lesser'}>{this.filterTypeLabels['lesser']}</option>
                                        <option value='regex' key={'regex'}>{this.filterTypeLabels['regex']}</option>
                                        <option value='is_null'
                                                key={'is_null'}>{this.filterTypeLabels['is_null']}</option>
                                        <option value='is_not_null'
                                                key={'is_not_null'}>{this.filterTypeLabels['is_not_null']}</option>
                                    </select>
                                </>}
                            </div>
                            <div className="col-6 col-md-3">
                                <label>
                                    Filter Value
                                </label>
                                <AdminFilterInput name="filterValue"
                                                  type={this.getCurrentFilterType()}
                                                  value={this.state.filterValue}
                                                  onChange={this.handleChange}/>
                            </div>
                            <div className="col-6 col-md-3">
                                <button type="submit" className="btn btn-sm btn-primary float-right px-3"
                                        style={{marginTop: '20px'}}>Add
                                </button>
                            </div>
                        </div>
                    </form>
                </>}
                {Object.keys(filters).length > 0 && <>
                    <div className="row mb-2 filter-row" style={{paddingTop: 12}}>
                        <div className="col-12">
                            {Object.keys(filters).map((key) => {
                                    const columnItem = columns.find(column => {
                                        return column.alias.find(alias => alias === key)
                                    });
                                    if (typeof columnItem === 'undefined') {
                                        return;
                                    }
                                    let filterStrArray = filters[key].split('|');
                                    filterShown = true
                                    return (
                                        <span className="badge badge-lg badge-primary mr-2 px-2 pl-3 mb-2" key={key}>
                        {columnItem.alias.length > 1 && columnItem.label + ': ' + key} {columnItem.alias.length === 1 && columnItem.label} {this.filterTypeLabels[filterStrArray[0]]}&nbsp;
                                            {(columnItem.valueLabels && columnItem.valueLabels[filterStrArray[1]]) ? columnItem.valueLabels[filterStrArray[1]] : filterStrArray[1]}<span
                                            className="badge badge-primary ml-1" onClick={() => this.onRemoveFilter(key)}><i
                                            className="fas fa-times"></i></span>
                      </span>
                                    )
                                }
                            )}
                            {filterShown && !this.state.presetOnSaveMode &&
                            <button type="submit" className="btn btn-xs"
                                    onClick={() => this.setPresetOnSaveMode()}>Tallenna ehdot
                            </button>
                            }
                            {Object.keys(filters).length > 0 && this.state.presetOnSaveMode &&
                            <div className="preset-save-wrapper">
                                <input type="text"
                                       name="presetName"
                                       value={this.state.presetName}
                                       className="form-control"
                                       placeholder="Preset Name"
                                       onChange={this.handleChange}
                                />
                                <button type="submit" className="btn btn-xs"
                                        onClick={() => this.onSaveFilters(this.state.presetName)}>Save
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                </>}
            </>
        );
    }
}
